import { Anchor, Flex, type FlexProps, Text } from '@mantine/core'
import Link from 'next/link'

import { useTranslation } from '@flecto/translations'

import type { ScheduleBooking } from '../../types/ScheduleBooking'

type CellIdProps = FlexProps & {
  booking: ScheduleBooking
}

export function CellId({ booking, ...props }: CellIdProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'schedule' })
  const { internal_id: id } = booking
  const bookingUrl = `/bookings/${id}`

  return (
    <Flex {...props} direction='column' gap='xs'>
      <Text size='sm'>{t('booking')}</Text>
      <Anchor component={Link} href={bookingUrl} fw='bold'>
        #{id}
      </Anchor>
    </Flex>
  )
}
